import controller from './controller';
import throttle from 'lodash/throttle';

let handled = false;

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', () => controller.init());
} else {
	controller.init();
}

window.addEventListener('load', controller.loaded);
window.addEventListener('scroll', throttle(controller.scrolled, 100), {
	passive: true,
});
window.addEventListener('resize', throttle(controller.resized, 100));
window.addEventListener('keydown', (e) => {
	controller.keyDown(e);
});

const handleMouseAndTouchEvents = (e) => {
	if (e.type === 'touchend') {
		handled = true;
		controller.mouseUp(e);
		// Safety net: if the synth mouseup never fires (scroll-cancelled
		// touch, element removed between events), clear the flag so future
		// real mouseups aren't swallowed.
		setTimeout(() => { handled = false; }, 500);
	} else if (e.type === 'mouseup') {
		if (handled) {
			handled = false;
		} else {
			controller.mouseUp(e);
		}
	}
};

document.addEventListener('mouseup', handleMouseAndTouchEvents);
document.addEventListener('touchend', handleMouseAndTouchEvents);
